import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import moment from 'moment/min/moment-with-locales';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleEvent, ScheduleViewModel } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { GameEventDetailsDialogComponent, GameEventDetailsDialogResult } from '../../../shared/components/game-event-details-dialog/game-event-details-dialog.component';

@Component({
    selector: 'app-schedule-month',
    imports: [CommonModule, MaterialModule, TranslateModule, RouterModule],
    templateUrl: './schedule-month.component.html',
    styleUrl: './schedule-month.component.css'
})
export class ScheduleMonthComponent {

    private route = inject(ActivatedRoute);
    private destroyRef = inject(DestroyRef);

    Days: Array<Date> = [];
    WeekIndex: Array<number> = [];
    DayActive: Array<boolean> = [];
    DayClass: Array<string> = [];
    daysOfMonth = [];
    schedule: ScheduleViewModel;
    currentYear: number;
    currentMonth: number;
    currentMonthText: string = "";
    isLoading: boolean = false;
    currentTz: string;
    selectedDate: Date;
    dialog = inject(MatDialog);

    constructor(private scheduleService: ScheduleService,
        public _router: Router,
        private _globals: Globals,
        private translate: TranslateService,
        private _snackBar: MatSnackBar) {
        moment.locale(this._globals.selectedLocale);

    }

    ngOnInit() {

        this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            // Access query params here
            const selectedDate = params['selectedDate'];

            if (selectedDate) {
                this.selectedDate = new Date(selectedDate);
                this.getScheduleData();
            }
        });

        //moment.locale('sv');
        /*  var now = new Date();
         this.currentYear = this.selectedDate().getFullYear();
         this.currentMonth = this.selectedDate().getMonth();
         var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 });//.add(1, 'months');
 
 
         this.currentMonthText = m.format('MMMM');
 
         this.getScheduleData(); */


    }

    ngOnChange() {
        // console.log("selectedDate changed: " + this.selectedDate);
        this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
            // Access query params here
            const selectedDate = params['selectedDate'];
            if (selectedDate) {
                this.selectedDate = new Date(selectedDate);
                this.getScheduleData();
            }

        });
    }


    getScheduleData() {
        //this.isLoading = true;
        //console.log(this.currentYear + '-' + (this.currentMonth+1));
        this.currentYear = this.selectedDate.getFullYear();
        this.currentMonth = this.selectedDate.getMonth();
        this.scheduleService.getSchedule(this.currentYear, this.currentMonth + 1).subscribe(data => {
            this.schedule = data;
            //console.log('hej');
            let a = moment(data.StartDateForMonthView);
            let b = moment(data.EndDateForMonthView);
            let tempDate = a;
            let daysCount = b.diff(a, 'days');
            this.Days = [];
            this.DayClass = [];

            //console.log('*dayscount' + daysCount);
            for (let i = 0; i <= daysCount; i++) {

                this.Days.push(tempDate.toDate());

                var tmpClass = "calendar-day ";
                if (tempDate < moment(data.StartDateForMonth) || tempDate > moment(data.EndDateForMonth)) {
                    tmpClass += " calendar-day-outofrange ";
                }
                if (tempDate.isSame(moment().toDate())) {
                    tmpClass += " calendar-day-today ";
                }
                //console.log(tempDate);
                //console.log(moment().toDate());

                this.DayClass.push(tmpClass);


                tempDate = tempDate.add(1, 'day');

            }

            //console.log(this.schedule.EventList);
            this.isLoading = false;

        });
    }

    getEvents(day: Date): Array<ScheduleEvent> {
        /* console.log(this.schedule.EventList.filter( event=>{
          return moment(event.EventStart).isSame(moment(day), 'day');
        })); */

        return this.schedule.EventList.filter(event => {
            return moment(event.EventStart).isSame(moment(day), 'day');
        });
    }


    openGameDetails(event: ScheduleEvent) {
        const dialogRef = this.dialog.open(GameEventDetailsDialogComponent, {
            maxWidth: '520px',
            width: '92vw',
            panelClass: 'event-details-dialog',
            data: event,
        });

        dialogRef.afterClosed().subscribe((result: GameEventDetailsDialogResult | undefined) => {
            if (result?.action === 'delete' && result.eventId) {
                this.deleteEventFromCalendar(result.eventId);
            } else if (result?.action === 'viewGame' && result.gameId) {
                this._router.navigate(['/games', result.gameId]);
            }
        });
    }

    addEventToCalendar(evt: ScheduleEvent) {
        // console.log(evt);

    }

    deleteEventFromCalendar(EventId: string) {
        //console.log(EventId);    
        this.scheduleService.removeEventFromSchedule(EventId).subscribe(res => {
            //console.log(res);
            this.openSnackBar("EVENT REMOVED", "CLOSE");
            this.getScheduleData();
        });

    }

    nextMonth() {
        var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).add(1, 'months');

        //console.log(m.format('MMMM'));
        this.currentYear = m.year();
        this.currentMonth = m.month();
        this.currentMonthText = m.format('MMMM');

        this.getScheduleData();

    }

    previousMonth() {
        var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).subtract(1, 'months');
        //console.log(m);
        this.currentYear = m.year();
        this.currentMonth = m.month();
        this.currentMonthText = m.format('MMMM');
        this.getScheduleData();

    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
        });
    }


}
